import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar } from '@fortawesome/pro-solid-svg-icons';

import { connect } from 'react-redux';
import { addStep } from './store/workflow/actions';

import AddControl from 'components/add_control/v2';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';

const VoucherApprovalWorkflowEmptyState = ({ addStep }) => {
  return (
    <Empty className="bg-white">
      <Empty.Media>
        <FontAwesomeIcon icon={faFileInvoiceDollar} />
      </Empty.Media>
      <Empty.Content>Get started by clicking on the "Add Workflow" button</Empty.Content>
      <Empty.Actions>
        <AddControl label="Add Workflow" onClick={addStep} />
      </Empty.Actions>
    </Empty>
  );
};

VoucherApprovalWorkflowEmptyState.propTypes = {
  addStep: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  addStep,
};

export default connect(null, mapDispatchToProps)(VoucherApprovalWorkflowEmptyState);
